<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 17 4`"
    :width="getWidth"
  >
    <path d="M3.98296108,1.90749617 C3.98296108,2.39829617 3.81118366,2.81546991 3.46762366,3.15902991 C3.12406366,3.50258991 2.70688992,3.67436733 2.21608992,3.67436733 C1.72528992,3.67436733 1.30811617,3.50258991 0.964556173,3.15902991 C0.620996173,2.81546991 0.44921875,2.39829617 0.44921875,1.90749617 C0.44921875,1.41669617 0.620996173,0.999522423 0.964556173,0.655962423 C1.30811617,0.312402423 1.72528992,0.140625 2.21608992,0.140625 C2.70688992,0.140625 3.12406366,0.312402423 3.46762366,0.655962423 C3.81118366,0.999522423 3.98296108,1.41669617 3.98296108,1.90749617 Z M10.2160899,1.90749617 C10.2160899,2.39829617 10.0443125,2.81546991 9.70075249,3.15902991 C9.35719249,3.50258991 8.94001875,3.67436733 8.44921875,3.67436733 C7.95841875,3.67436733 7.54124501,3.50258991 7.19768501,3.15902991 C6.85412501,2.81546991 6.68234758,2.39829617 6.68234758,1.90749617 C6.68234758,1.41669617 6.85412501,0.999522423 7.19768501,0.655962423 C7.54124501,0.312402423 7.95841875,0.140625 8.44921875,0.140625 C8.94001875,0.140625 9.35719249,0.312402423 9.70075249,0.655962423 C10.0443125,0.999522423 10.2160899,1.41669617 10.2160899,1.90749617 Z M16.4492188,1.90749617 C16.4492188,2.39829617 16.2774413,2.81546991 15.9338813,3.15902991 C15.5903213,3.50258991 15.1731476,3.67436733 14.6823476,3.67436733 C14.1915476,3.67436733 13.7743738,3.50258991 13.4308138,3.15902991 C13.0872538,2.81546991 12.9154764,2.39829617 12.9154764,1.90749617 C12.9154764,1.41669617 13.0872538,0.999522423 13.4308138,0.655962423 C13.7743738,0.312402423 14.1915476,0.140625 14.6823476,0.140625 C15.1731476,0.140625 15.5903213,0.312402423 15.9338813,0.655962423 C16.2774413,0.999522423 16.4492188,1.41669617 16.4492188,1.90749617 Z" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-more'

  export default {
    name: 'SvgIconMore',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '4',
        type: String
      },
      width: {
        default: '17',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconMore.vue